module.exports = __webpack_public_path__ + "img/Wasserrettungsverband.36d81cc5.svg";